// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__R17jp","child1":"style_child1__DpViE","child2":"style_child2__z-Z3B","content":"style_content__Idk68"};